import { useExperiments } from '@wix/wix-experiments-react';

// Single Petri spec gating the Phase 1 additions to the unknown-charge
// results page (login-to-account CTA + masked Wix account email row).
// Keeps the spec name in one place so server- and client-side gates stay
// aligned. See PREM2-30172.
export const RESULTS_PAGE_PHASE1_SPEC =
  'specs.premium.UnknownChargeResultsPagePhase1';

export const useResultsPagePhase1 = (): boolean => {
  const { experiments } = useExperiments();
  return experiments.enabled(RESULTS_PAGE_PHASE1_SPEC);
};
